import type { AllRouteEndpoints } from "../routeTypes";

export const engagementSegments = "/engagement/segments";
export const engagementSegmentsCacheKeys: AllRouteEndpoints[] = [engagementSegments];
